module.exports = "/_next/static/images/kickoff-logo-standard-56fb22563530e082e8cfa0a9eeefee0b.svg";